import { createClient } from '@supabase/supabase-js';

// Publishable keys only. The service-role key is never in this app — the
// create-client-notification Edge Function is what holds privilege.
const url = import.meta.env.VITE_SUPABASE_URL || 'https://accgqlktubtghwzudzrm.supabase.co';
const anonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFjY2dxbGt0dWJ0Z2h3enVkenJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU4NTM0NjMsImV4cCI6MjEwMTQyOTQ2M30.OkD3e-XvFetCmf-NVrUm55-GJLGjY2vUPnDLoxvd1JA';

export const supabase = createClient(url, anonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

export default supabase;